import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectCatalogState = (state: RootState) => state.sixCatalog;

export const selectCatalogSixes = createSelector(
  selectCatalogState,
  (catalog) => catalog.sixes
);

export const selectCatalogLoading = createSelector(
  selectCatalogState,
  (catalog) => catalog.loading
);

export const selectCatalogError = createSelector(
  selectCatalogState,
  (catalog) => catalog.error
);

export const selectCatalogSearch = createSelector(
  selectCatalogState,
  (catalog) => catalog.search
);

export const selectFilteredCatalogSixes = createSelector(
  selectCatalogSixes,
  selectCatalogSearch,
  (sixes, search) =>
    (search == null)
      ? sixes
      : sixes.filter(
          (six) =>
            six.name.toLowerCase().includes(search.toLowerCase()) ||
            (six.description.toLowerCase().includes(search.toLowerCase()))
        )
);

export const selectSixById = createSelector(
  selectCatalogSixes,
  (_: RootState, sixId: string) => sixId,
  (sixes, sixId) => sixes.find(six => six.id === sixId)
);
